export default {
  API_ENDPOINT: 'https://blooming-reef-25668.herokuapp.com/api',
  // API_ENDPOINT: 'http://localhost:8000/api',
  TOKEN_KEY: 'dog-parks-client-auth-token',
};